import { configureStore } from '@reduxjs/toolkit';
import helpReducer from './features/help/helpSlice';
import depatureBoardReducer from './features/departureBoard/departureBoardSlice';
import configReducer from './features/config/configSlice';
import sendMessageToTeamReducer from './features/sendMessageToTeam/sendMessageToTeamSlice';
import welcomeMessagesPanelReducer from './features/welcomeMessages/welcomeMessagesSlice';
import reportingBoardReducer from './features/reporting/reportingSlice';
import customerUpdatesReducer from './features/customerUpdates/customerUpdatesSlice';
import broadcastMessageReportSlice from './features/broadcastMessageReport/broadcastMessageReportSlice';
import appConfigurationReducer from './features/appConfiguration/appConfigurationSlice';
import autoRepliesPanelReducer from './features/autoReplies/autoRepliesSlice';
import categoriesPanelReducer from './features/categories/categoriesSlice';
import activeConversationsSlice from './features/activeConversations/activeConversationsSlice';
import reportingDashboardSlice from './features/reportingDashboard/reportingDashboardSlice';
import flightNumbersPanelReducer from './features/flightNumbers/flightNumbersSlice';
import healthDashboardReducer from './features/healthDashboard/healthDashboardSlice';
import allowedCrewMembersReducer from './features/allowedCrewMembers/allowedCrewMembersSlice';
import conversationStatusesReducer from './features/conversationStatuses/conversationStatusesSlice';

export const store = configureStore({
    reducer: {
        appConfiguration: appConfigurationReducer,
        config: configReducer,
        help: helpReducer,
        departureBoard: depatureBoardReducer,
        activeConversations: activeConversationsSlice,
        sendMessageToTeam: sendMessageToTeamReducer,
        customerUpdates: customerUpdatesReducer,
        reportingBoard: reportingBoardReducer,
        broadcastMessageReport: broadcastMessageReportSlice,
        welcomeMessagesPanel: welcomeMessagesPanelReducer,
        autoRepliesPanel: autoRepliesPanelReducer,
        categoriesPanel: categoriesPanelReducer,
        reportingDashboard: reportingDashboardSlice,
        flightNumbersPanel: flightNumbersPanelReducer,
        healthDashboard: healthDashboardReducer,
        allowedCrewMembers: allowedCrewMembersReducer,
        conversationStatuses: conversationStatusesReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
